import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const EditableTable = ({ data, onDataChange }) => {
    const INTEGER_COLS = ["N_Cierres_Mensual", "N_Cierres_Anual", "Visualizaciones_Propiedades", "N_Stocks"];
    const DECIMAL_COLS = ["Ingreso_Mes", "Meta_Trimestral", "Meta_Anual", "Ingreso_Anual", "Ingreso_Trimestral"];

    const handleCellChange = (id, field, value) => {
        let newValue = value;

        if (INTEGER_COLS.includes(field)) {
            // Only allow digits and an optional leading minus sign, no letters, no decimals
            newValue = newValue.replace(/[^0-9-]/g, '');
            // Prevent minus sign in the middle
            if (newValue.indexOf('-') > 0) {
                newValue = newValue.replace(/-/g, '');
            }
        } else if (DECIMAL_COLS.includes(field)) {
            // Replace comma with dot, block letters
            newValue = newValue.replace(/,/g, '.').replace(/[^0-9.-]/g, '');
            // Prevent minus sign in the middle
            if (newValue.indexOf('-') > 0) {
                newValue = '-' + newValue.replace(/-/g, '');
            }
            // Prevent multiple dots
            const parts = newValue.split('.');
            if (parts.length > 2) {
                newValue = parts[0] + '.' + parts.slice(1).join('');
            }
        }

        const newData = data.map((row) => {
            if (row.id === id) {
                return { ...row, [field]: newValue };
            }
            return row;
        });
        onDataChange(newData);
    };

    const handleDeleteRow = (id) => {
        const newData = data.filter((row) => row.id !== id);
        onDataChange(newData);
    };

    if (!data || data.length === 0) return null;

    const headers = Object.keys(data[0]).filter((key) => key !== "id");

    return (
        <TableContainer component={Paper} sx={{ mt: 3, maxHeight: 500 }}>
            <Table stickyHeader size="small" aria-label="cierre mensual table">
                <TableHead>
                    <TableRow>
                        {headers.map((header) => (
                            <TableCell key={header} sx={{ fontWeight: "bold" }}>
                                {header}
                            </TableCell>
                        ))}
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>Acciones</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row) => (
                        <TableRow key={row.id}>
                            {headers.map((header) => (
                                <TableCell key={`${row.id}-${header}`}>
                                    <TextField
                                        variant="standard"
                                        value={row[header] !== undefined && row[header] !== null ? row[header] : ""}
                                        onChange={(e) => handleCellChange(row.id, header, e.target.value)}
                                        fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                fontSize: "0.875rem",
                                                padding: "4px 8px",
                                                border: "1px solid transparent",
                                                borderRadius: "4px",
                                                "&:hover": {
                                                    border: "1px solid #e0e0e0",
                                                    backgroundColor: "#f9f9f9",
                                                },
                                                "&.Mui-focused": {
                                                    border: "1px solid #1976d2",
                                                    backgroundColor: "#fff",
                                                },
                                            },
                                        }}
                                    />
                                </TableCell>
                            ))}
                            <TableCell align="center">
                                <IconButton
                                    aria-label="delete"
                                    size="small"
                                    color="error"
                                    onClick={() => handleDeleteRow(row.id)}
                                >
                                    <DeleteIcon fontSize="inherit" />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default EditableTable;
